// @owners { team: patients }
import { type ReduxStateShared } from '~shared/store';

export const getAnnouncementViewedStatus = (state: ReduxStateShared, announcementID?: number) => {
  if (!announcementID) return false;

  return state.persistedUI.announcements.viewedAnnouncements[announcementID] || false;
};
